export const MESSAGE_CONSTANTS = {
  COMMON: {
    INSERT: (target = '해당 항목') => `${target}을 등록하시겠습니까?`,
    UPDATE: (target = '해당 항목') => `${target}을 수정하시겠습니까?`,
    SAVE: (target = '해당 항목') => `${target}을 저장하시겠습니까?`,
    DELETE: (target = '해당 항목') => `${target}을 삭제하시겠습니까?`,
    RESTORE: (target = '해당 항목') => `${target}을 복구하시겠습니까?`,
    FORCEDELETE: (target = '해당 항목') => `${target}을 완전히 삭제하시겠습니까?`,
    TEMPSAVE: (target = '해당 항목') => `${target}을 임시저장하시겠습니까?`,
    CANCEL: '취소하시겠습니까?'
  },
  SUCCESS: {
    INSERT: '정상적으로 등록이 완료되었습니다.',
    UPDATE: '정상적으로 수정이 완료되었습니다.',
    DELETE: '정상적으로 삭제가 완료되었습니다.',
    SAVE: '정상적으로 저장이 완료되었습니다.',
    SELECT: '정상적으로 조회가 완료되었습니다.',
    RESTORE: '정상적으로 복구가 완료되었습니다.',
    FORCEDELETE: '정상적으로 완전 삭제가 완료되었습니다.',
    FILE_DELETE: '정상적으로 파일 삭제가 완료되었습니다.'
  },
  INFO: {
    SELECT: (target = '항목') => `${target}을/를 선택해주세요.`
  },
  VALID: {
    REQUIRED: (target = '해당 항목') => `${target}은/는 필수값입니다.`,
    MAX: (target = '해당 항목', max = 100) => `${target}은/는 최대 ${max}자리까지 입력 가능합니다.`,
    MIN: (target = '해당 항목', min = 10) => `${target}은/는 최소 ${min}자리부터 입력 가능합니다.`,
    NUMTYPE: (target = '해당 항목') => `${target}은/는 숫자만 입력 가능합니다.`
  },
  PASSWORD: {
    ERROR: {
      CONFIRM: '비밀번호와 비밀번호 확인이 일치하여야합니다.'
    }
  },
  ID: {
    ERROR: {
      EXIST: '이미 존재하는 아이디입니다.'
    },
    SUCCESS: {
      AVAILABLE: '사용 가능한 아이디입니다.'
    }
  },
  MENUMNG: {
    INFO: {
      AUTH: '등록 후 메뉴 생성관리에서 권한별로 메뉴를 등록해야 이용이 가능합니다.'
    },
    ERROR: {
      UPDATE_ON_INSERT_MODE: '상세조회 시 수정 혹은 삭제만 가능합니다.',
      INSERT_ON_UPDATE_MODE: '상세조회 시 수정 혹은 삭제만 가능합니다. 초기화 하신 후 등록하세요.'
    }
  },
  FILE: {
    ERROR: {
      MIN_CNT: (minLength = 1) => `${minLength}개 이상의 파일이 업로드되어야합니다.`,
      MAX_CNT: (maxLength = 1, unavailableFiles = '') =>
        `업로드 실패한 파일이 있습니다. [파일 갯수 초과] - 최대 ${maxLength}개 ${unavailableFiles}`,
      MAX_SIZE: (maxSize = 100, fileName = '') =>
        `업로드 실패한 파일이 있습니다. [파일 크기 초과] - ${maxSize}MB. ${fileName}`,
      EXT: (fileName = '') => `업로드 실패한 파일이 있습니다. [첨부할 수 없는 확장자] ${fileName}`,
      UPLOAD_FAIL: '파일 업로드에 실패하였습니다. 잠시 후 다시 시도해주세요.',
      ZERO_SIZE: () => `파일 용량이 0B입니다. 다시 첨부해주세요.`
    }
  },
  INSTR_FEE: {
    INFO: {
      RESET: '강의료지급 데이터를 초기화 합니다\n\n지급내역,지급확인내역 및 강사서명정보가 초기화 됩니다.'
    }
  },
  LIST: {
    INFO: {
      SELECT: '선택한 항목으로 처리하시겠습니까?',
      DELETE_COMPLETE: '완전삭제 하시겠습니까?',
      RESTORE: '복구하시겠습니까?'
    }
  },
  CONFIRM_YN: {
    Y: '승인 처리하시겠습니까?',
    N: '미승인 처리하시겠습니까?'
  },
  WEB_PUSH: {
    TOKEN: {
      SEND: '대상을 선택하지 않으면  전체가 대상이되어 문자발송이 됩니다.\n\n 진행하시겠습니까?'
    }
  },
  BOARD_MASTER: {
    INFO: {
      MNTR_TYPE: '모니터링 게시판으로 사용할 경우 \n반드시 정회원에게 쓰기 권한을 설정해 주세요.',
      AUTH: '수정, 삭제, 답변은 관리자만 할당 해주어야 하며, 일반 회원은 할당해주어서는 안됩니다.'
    }
  },
  VOTE: {
    DETAIL: {
      RESTORE: '복원 하시겠습니까?',
      DELETE: '삭제하시겠습니까?',
      BASE_UPDATE: '수정 하시겠습니까?\n\n (질문에 대한 사항은 변경되지 않습니다.)'
    }
  },
  USER: {
    INFO: {
      RESET_LOGIN_CNT: '로그인 횟수를 초기화 하시겠습니까?'
    }
  },
  DAILY_APPLY: {
    APPLY_MAX_COUNT: {
      UPDATE: '모집인원을 수정하시겠습니까?'
    }
  },
  RCMDTN_PPL_LCTR: {
    SUCCESS: {
      SORT_SEQ: '순서가 정상적으로 변경되었습니다.'
    }
  }
}


